import Styled from 'styled-components';
import { desktop, tablet, mobile } from '../../utils/constants';

export const Description = Styled.p`
  flex: 1 1 auto;

  @media all and (min-width: ${desktop}) {
    max-width: 83%;
  }

  @media all and (max-width: 1023px) and (min-width: ${tablet}) {
    max-width: 83%;
  }
`;

export const DescriptionContainer = Styled.div`
  @media all and (min-width: ${desktop}) {
    display: flex;
    flex-direction: row;
  }

  @media all and (max-width: 1023px) and (min-width: ${tablet}) {
    display: flex;
    flex-direction: row;
  }
`;

export const MeasuringTipsLink = Styled.p`
  color: #3E7697;
  cursor: pointer;
`;

export const MeasuringTipsLinkContainer = Styled.div`
  @media all and (min-width: ${desktop}) {
    text-align: right; 
    flex: 1 1 auto;
    cursor: pointer;
  }

  @media all and (max-width: 1023px) and (min-width: ${tablet}) {
    text-align: right; 
    flex: 1 1 auto;
  }

  @media all and (max-width: 767px) and (min-width: ${mobile}) {
    margin: 1.5rem 0 0 0;
  }
`;

export const RoomGridTitleWrapper = Styled.div`
padding-bottom: 2.5rem;
@media all and (min-width: ${desktop}) {
  text-align: left; 
}

@media all and (max-width: 1023px) and (min-width: ${tablet}) {
  text-align: left; 
}

@media all and (max-width: 767px) and (min-width: ${mobile}) {
  margin: 1.5rem 0 0 0;
}
`;

export const RoomTitleWrapper = Styled.div`
font-weight: bold;
padding-top: 2.5rem;

@media all and (min-width: ${desktop}) {
 }
 
 @media all and (max-width: 1023px) and (min-width: ${tablet}) {
 
 }
 @media all and (max-width: 767px) and (min-width: ${mobile}) {
  padding-bottom: 2.5rem;

}
`;

export const RoomGrids = Styled.div`
display: grid;
max-width: 100%;
@media all and (min-width: ${desktop}) {
  padding-top: 2.5rem;
 grid-template-columns: repeat(3, 1fr);
 grid-auto-rows: minmax(180px, auto);
 gap: 16px;
}

@media all and (max-width: 1023px) and (min-width: ${tablet}) {
  padding-top: 2.5rem;
  text-align: left; 
  grid-template-columns: repeat(2, 1fr);
  grid-auto-rows: minmax(180px, auto);
  gap: 16px;
}

@media all and (max-width: 767px) and (min-width: ${mobile}) {
  grid-template-columns: repeat(1, 1fr);
  grid-auto-rows: minmax(147px, auto);
  gap: 1.5rem;
}
`;

export const AddRoomButtonWrapper = Styled.div`
@media all and (min-width: ${desktop}) {
 width: 200px; 
}

@media all and (max-width: 1023px) and (min-width: ${tablet}) {
  width: 200px;  
}

@media all and (max-width: 767px) and (min-width: ${mobile}) {
 width: 100%
}
`;
